import useSmartModalLogic from "../../../../../../components/Hooks/useSmartModalLogic"

export default function useUploadDocumentsModal({
    isLoadingHttpRequest,
    deleteHandler,
}){

    const deleteModalLogic = useSmartModalLogic({
        modalMessage: 'Please confirm to delete the file.',
        staticDisplay: 'static',
        size: 'md',
        hideModal: isLoadingHttpRequest,
        onConfirmHandler: deleteHandler,
        confirmButtonColor: 'danger'
    })

    return {
        deleteModalLogic
    }
}